import { Vue, Component, Prop } from 'vue-property-decorator';
import ClassDetails from './class-details/class-details';
import CourseDetails from './course-details/course-details';
import EnrollmentDetails from './enrollment-details/enrollment-details';
import OrgDetails from './org-details/org-details';
import UserDetails from './user-details/user-details';

@Component({
    name: 'success-list',
    components: {
        'orgs-details': OrgDetails,
        'class-details': ClassDetails,
        'users-details': UserDetails,
        'enrollment-details': EnrollmentDetails,
        'course-details': CourseDetails,
    },
})

export default class UploadStatistics extends Vue {

    // -----------------------------------------------------
    // Properties

    @Prop()
    private activeRoster: any;

    @Prop({default: false})
    private showSourceId: any;

    private get activeComponent() {
        return this.componentList[this.activeRoster.activeType.recoredKey];
    }

    private componentList: any = {
        orgs: 'orgs-details',
        classes: 'class-details',
        users: 'users-details',
        courses: 'course-details',
        enrollments: 'enrollment-details',
    };

    private tableFields: any = [
        {
            label: 'Title',
            key: 'title',
        },
        {
            label: 'Sourced Id',
            key: 'sourcedId',
        },
        {
            label: 'Errors',
            key: 'errors',
        },
    ];

}
